import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  mode: 'light',
  black,
  white,
  primary: {
    contrastText: white,
    // dark: colors.indigo[900],
    main: colors.blue[800],
    // light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: '#212121',
    disabled: '#BDBDBD',
    main: colors.grey[200],
    // light: colors.blue['A400'],
  },
  error: {
    contrastText: white,
    dark: colors.deepOrange[900],
    main: colors.red[500],
    light: colors.red[200],
  },
  warning: {
    main: colors.orange[100],
  },
  info: {
    main: colors.grey[300],
  },
  success: {
    main: colors.green[200],
  },
  off: {
    main: colors.grey[200],
  },
  // 额外的自定义颜色
  text: {
    primary: colors.blue[800],
    secondary: colors.grey[700],
    lesser: colors.grey[500],
    link: colors.blue[600],
  },
  link: colors.grey[700],
  icon: colors.blueGrey[600],
  background: {
    default: colors.grey[50],
    paper: white,
    label: colors.grey[500],
    icon: colors.grey[200],
  },
  divider: colors.grey[400],
  chart: {
    lightBlue001: colors.lightBlue[600],
    lightBlue002: colors.lightBlue[200],
    red001: colors.red[500],
    green001: colors.green[800],
  },
  line: colors.grey[500],
  action: {
    active: colors.grey[100],
    hover: colors.grey[100],
    selected: colors.grey[300],
    disabled: 'rgba(255, 255, 255, 0.26)', //'darkgray'
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    focus: 'rgba(255, 255, 255, 0.12)',
  },
};
